"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "feltindikator", {
    enumerable: true,
    get: function() {
        return feltindikator;
    }
});
var feltindikator = function(valideringer) {
    return function(felt) {
        if (felt.valideringer) {
            return felt.valideringer.map(function(valideringkey) {
                return valideringer[valideringkey];
            }).filter(function(validering) {
                return validering.feltindikator;
            }).map(function(validering) {
                return validering.feltindikator;
            }).join(" ");
        }
        return undefined;
    };
};
